<template>
  <v-data-table
    :headers="tableHeaders"
    :items="workScheduleDays"
    disable-sort
    disable-pagination
    hide-default-footer
    sort-by="day"
  >
    <template v-slot:item.day="{ item }">
      {{ item.day }}
    </template>
    <template v-slot:item.category="{ item }">
      {{ getReadableCategory(item.category) }}
    </template>
    <template v-slot:item.startTime="{ item }">
      {{ getWorkingStartTime(item.segments) }}
    </template>
    <template v-slot:item.endTime="{ item }">
      {{ getWorkingEndTime(item.segments) }}
    </template>
    <template v-slot:item.breaks="{ item }">
      {{ getBreaksSummary(item.segments) }}
    </template>
    <template v-slot:item.workingDuration="{ item }">
      {{ getWorkingDuration(item.segments) }}
    </template>
  </v-data-table>
</template>

<script>
import constants from '@/constants';
import isEmpty from 'lodash/isEmpty';
import first from 'lodash/first';
import last from 'lodash/last';
import filter from 'lodash/filter';
import sum from 'lodash/sum';
import map from 'lodash/map';
import DateTimeUtil from '@/util/date-time-util';

export default {
  name: 'WorkScheduleDetailsTable',

  props: {
    workScheduleDays: Array,
  },

  data() {
    return {
      tableHeaders: [
        {
          text: 'Day',
          value: 'day',
          align: 'start',
        },
        {
          text: 'Category',
          value: 'category',
          align: 'start',
        },
        {
          text: 'Start Time',
          value: 'startTime',
          align: 'start',
        },
        {
          text: 'End Time',
          value: 'endTime',
          align: 'start',
        },
        {
          text: 'Break(s)',
          value: 'breaks',
          align: 'start',
        },
        {
          text: 'Working Duration',
          value: 'workingDuration',
          align: 'start',
        },
      ],
    };
  },

  methods: {
    getReadableCategory(category) {
      switch (category) {
        case constants.WorkSchedule.DayCategory.DAY_MODEL: return 'Day Model';
        case constants.WorkSchedule.DayCategory.PLANNED_HOURS: return 'Planned Hours';
        case constants.WorkSchedule.DayCategory.OFF: return 'Non-Working Day';
        default: return 'Unknown';
      }
    },

    getWorkingStartTime(segments) {
      return isEmpty(segments) ? '-' : first(segments).startTime;
    },

    getWorkingEndTime(segments) {
      return isEmpty(segments) ? '-' : last(segments).endTime;
    },

    getBreaksSummary(segments) {
      const breaks = filter(
        segments,
        (segment) => segment.category === constants.WorkSchedule.SegmentType.SCHEDULED_UNPAID_BREAK,
      );
      const pluralString = breaks.length > 1 ? 's' : '';

      return isEmpty(breaks)
        ? 'No breaks defined'
        : `${breaks.length} break${pluralString}
        (${sum(map(breaks, (unpaidBreak) => unpaidBreak.minuteDuration))} minutes)`;
    },

    getWorkingDuration(segments) {
      const workingSegments = filter(
        segments,
        (segment) => segment.category === constants.WorkSchedule.SegmentType.SCHEDULED_WORKING_TIME,
      );

      const minuteDuration = isEmpty(workingSegments)
        ? 0
        : sum(map(workingSegments, (segment) => segment.minuteDuration));

      return DateTimeUtil.getFormattedDuration(minuteDuration);
    },
  },
};
</script>

<style scoped>

</style>
